import { Link } from 'react-router-dom';
import { Mutation } from '@apollo/client/react/components';
import React, { Component } from 'react';
import VerificationItem from './VerificationItem';
import { Loader } from '../../../components/Loader';
import { Form, Table, Button, Row, Col, ButtonToolbar, ButtonGroup, InputGroup, FormControl, Modal } from 'react-bootstrap';

import { createVerifications } from '../api';
import { verificationObject } from '../utils';

export default class ImportForm extends Component {
  state = {
    rows: [],
    rowAmount: 0,
  };

  renderRows = () =>
    this.state.rows.map((item, key) => {
      return (
        <VerificationItem
          key={key}
          index={key}
          item={item}
          users={this.props.users}
          removeItem={this.removeItem}
          setBarcode={this.setBarcode}
          setUser={this.setUser}
          department={this.props.currentRole.departmentAbbreviation}
          userId={this.props.userId}
          setComment={this.setComment}
        />
      );
    });

  removeItem = (index) => {
    this.setState({
      rows: this.state.rows.filter((item, key) => key !== index),
    });
  };

  setBarcode = (value, index) => {
    this.setState({
      rows: this.state.rows.map((item, key) => {
        if (index === key) {
          item.BarCodeNumber = value;
        }
        return item;
      }),
    });
  };

  setComment = (value, index) => {
    this.setState({
      rows: this.state.rows.map((item, key) => {
        if (index === key) {
          item.comment = value;
        }

        let commentArray = [];
        let comment = {
          comment: value,
          createdBy: this.props.adId,
        };
        commentArray.push(comment);
        item.comments = commentArray;

        return item;
      }),
    });
  };

  setUser = (userId, index) => {
    this.setState({
      rows: this.state.rows.map((item, key) => {
        if (index === key) {
          item.UserId = userId;
        }
        item.VerifyDate = Date.now();
        return item;
      }),
    });
  };

  mutationHandler = (mutation) => {
    if (this.state.rows.length > 0) {
      this.setState({
        rows: this.state.rows.map((item, key) => {
          delete item.comment;
          return item;
        }),
      });

      mutation({
        variables: {
          verifications: this.state.rows,
          userDepartmentId: this.props.currentRole.departmentId,
        },
      });
    } else alert("Please add an item you'd like to verify");
  };

  notifyUser = (loading, data) => {
    if (loading) {
      return (
        <Modal show={true}>
          <Loader title='Verifying Items' />
        </Modal>
      );
    } else if (data.syncScans) {
      return (
        <Modal show={true}>
          <Modal.Header>
            <Modal.Title>Items were verified</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h6 className='text-center'>Where would you like to go?</h6>
            <Modal.Footer className='mx-auto'>
              <Button variant='secondary'>
                <Link to='/'>Dashboard</Link>
              </Button>
              <Button variant='secondary'>
                <Link to='/inventory'>Inventory</Link>
              </Button>
            </Modal.Footer>
          </Modal.Body>
        </Modal>
      );
    } else {
      alert('There was an error trying to update this item.');
    }
  };

  render() {
    return (
      <Mutation mutation={createVerifications}>
        {(mutation, { loading, data, called }) => (
          <Form style={{ overflowX: 'hidden' }}>
            <Row className='mt-3'>
              <Col sm={8} />
              <Col sm={1}>
                <Button
                  onClick={() =>
                    this.setState({
                      rows: [...this.state.rows, verificationObject(this.props.currentRole.departmentId, this.props.userId)],
                    })
                  }>
                  {' '}
                  Add Single Row{' '}
                </Button>
              </Col>
              <Col sm={3}>
                <ButtonToolbar className='mb-3'>
                  <InputGroup>
                    <FormControl
                      type='number'
                      placeholder='Items'
                      value={this.state.rowAmount}
                      onChange={(e) => this.setState({ rowAmount: e.target.value })}
                    />
                  </InputGroup>
                  <ButtonGroup className='mr-2'>
                    <Button
                      onClick={() => {
                        let items = [];

                        for (let index = 0; index < this.state.rowAmount; index++) {
                          items.push(verificationObject(this.props.currentRole.departmentId, this.props.userId));
                        }

                        this.setState({
                          rows: [...this.state.rows, ...items],
                          rowAmount: 0,
                        });
                      }}>
                      {' '}
                      Add Rows{' '}
                    </Button>
                  </ButtonGroup>
                </ButtonToolbar>
              </Col>
            </Row>
            <Row>
              <Col sm={1} />
              <Col sm={10}>
                <Table striped bordered hover className='mb-2'>
                  <thead>
                    <tr>
                      <th>Barcode</th>
                      <th>User</th>
                      <th>Comment</th>
                      <th>Department</th>

                      <th></th>
                    </tr>
                  </thead>
                  <tbody>{this.renderRows()}</tbody>
                </Table>
              </Col>
            </Row>
            <Row className='justify-content-center mt-2'>
              <Button variant='success' onClick={() => this.mutationHandler(mutation)}>
                Submit
              </Button>
            </Row>
            {called ? this.notifyUser(loading, data) : null}
          </Form>
        )}
      </Mutation>
    );
  }
}
